// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__ftsk0","btn_icon":"Button_btn_icon__Dtuso"};